import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, reset, touch, focus, isValid } from 'redux-form';

import { Button } from 'semantic-ui-react';

import * as attachLib from 'libs/attachLib';
import * as attachActions from 'modules/templateAttach';
import * as currentStatusActions from 'modules/currentStatus';

import { ExamAttachAdd } from 'components';

class CtExamAttachAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInvalid: false,
      isLoading: false,

      // 실행 파일
      attachFile: [],
      // 아이콘
      fileIcon: [],
      // 실행 결과
      actionImage: []
    };

    this.onToggleSelected = this.onToggleSelected.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { setDisableSave } = this;
    const { formStore } = nextProps;

    if (formStore && formStore.fields) {
      const errorType = ['syncErrors', 'syncWarnings', 'asyncErrors', 'asyncWarnings'];

      let anyError = false;
      for (const field in formStore.fields) {
        if (
          formStore.fields.hasOwnProperty(field) &&
          formStore.fields[field].touched &&
          formStore.fields[field].visited &&
          formStore.registeredFields[field] &&
          formStore.registeredFields[field].count > 0
        ) {
          for (let i = 0, l = errorType.length; i < l; i++) {
            if (formStore[errorType[i]] && formStore[errorType[i]][field]) {
              anyError = true;
              if (typeof setDisableSave === 'function') {
                setDisableSave(true);
              }
              break;
            }
          }
        }
        if (anyError) {
          break;
        }
      }

      if (!anyError) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(false);
        }
      }
    }
  }

  onToggleModal = viewType => {
    const { ReduxFormReset } = this.props;
    ReduxFormReset('examAttachAdd');

    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 템플릿 버튼 선택
  onToggleSelected = values => {
    this.setState(values);
  };

  // 실행 파일 업로드
  setAttachFile = ({ type, file }) => {
    const stateParam = {};
    stateParam[type] = file[0];
    this.setState(stateParam);
  };

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  // 첨부파일 등록
  saveAttach = async () => {
    const { formStore, attachActions, isValidFormAttachAdd } = this.props;

    try {
      this.setState({ isLoading: true });

      // validation 체크
      if (isValidFormAttachAdd) {
        // 부가기능 & 제약사항
        const attachFunc = formStore.values.attachFunction;
        const attachRest = formStore.values.attachRestrict;
        const attachFunArray = {};
        const attachRestrictArray = {};

        if (attachFunc) {
          attachFunc.map((attachfunc, i) => {
            attachFunArray[attachfunc] = 1;
          });
        }
        if (attachRest) {
          attachRest.map((attachrest, i) => {
            attachRestrictArray[attachrest] = 1;
          });
        }

        const formData = new FormData();

        formData.append('attachSubject', formStore.values.attachSubject);
        formData.append('attachExamType', formStore.values.attachExamType);
        formData.append('attachCategory', formStore.values.attachCategory);

        if (attachFunArray) {
          formData.append('attachFunction', JSON.stringify(attachFunArray));
        }
        if (attachRestrictArray) {
          formData.append('attachRestrict', JSON.stringify(attachRestrictArray));
        }
        if (formStore.values.attachScreenType) {
          formData.append('attachScreenType', formStore.values.attachScreenType);
        }
        if (formStore.values.attachScreenContent) {
          formData.append('attachScreenContent', formStore.values.attachScreenContent);
        }
        // formData.append('attachDetail', formStore.values.attachDetail);
        if (this.state.attachFile) {
          formData.append('attachFile', this.state.attachFile);
        }
        if (this.state.fileIcon) {
          formData.append('fileIcon', this.state.fileIcon);
        }
        if (this.state.actionImage) {
          formData.append('actionImage', this.state.actionImage);
        }

        const respObj = await attachLib.addAttach(formData);
        if (respObj && respObj.status && respObj.status === 200) {
          this.onToggleModal('');
          attachActions.reloadAttach();
        }
      } else {
        this.markFieldValidate('examAttachAdd');
      }

      this.setState({ isLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isLoading } = this.state;
    const { onToggleModal, saveAttach, setAttachFile, onToggleSelected } = this;
    const { isModal, isAuth, formStore } = this.props;

    return (
      <div>
        <Button
          className="bt-style-gleam common-button-brand"
          size="small"
          content={defineMessages(formatMessage({ id: 'CtExamTemplateAdd_1', defaultMessage: '등 록' }))}
          onClick={() => {
            onToggleModal('examAttachAdd');
          }}
          color="blue"
        />
        {/* {isModal === 'examAttachAdd' && ( */}
        <ExamAttachAdd
          isAuth={isAuth}
          isLoading={isLoading}
          onToggleModal={onToggleModal}
          formStore={formStore}
          saveAttach={saveAttach}
          setAttachFile={setAttachFile}
          onToggleSelected={onToggleSelected}
          attachCategory={this.state.attachCategory}
          attachScreenType={this.state.attachScreenType}
          attachExamTypeCheck={this.state.attachExamType}
          isModal={isModal}
          fileData={{
            // 실행 파일
            attachFile: this.state.attachFile,
            // 아이콘
            fileIcon: this.state.fileIcon,
            // 실행 결과
            actionImage: this.state.actionImage
          }}
        />
        {/* )} */}
      </div>
    );
  }
}

CtExamAttachAdd.propTypes = {};
CtExamAttachAdd.defaultProps = {};

const mapStateToProps = state => {
  return {
    isModal: state.currentStatus.get('isModal'),
    formStore: state.form['examAttachAdd'],
    isValidFormAttachAdd: isValid('examAttachAdd')(state)
  };
};

const mapDispatchToProps = dispatch => ({
  attachActions: bindActionCreators(attachActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'examAttachAdd',
    enableReinitialize: true,
    touchOnChange: true
  })(injectIntl(CtExamAttachAdd))
);



// WEBPACK FOOTER //
// ./src/script/containers/examAttach/CtExamAttachAdd.js